<router-outlet></router-outlet>

<nexus-toast-container></nexus-toast-container>
<nexus-modal-container></nexus-modal-container>
